module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin",
    attrs: {
      "name": "value"
    }
  }, [_c('div', {
    staticClass: "flex-grid__g-7"
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "min": "0.00",
      "name": "value"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value') && _vm.include
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.label) + " is required and must be greater than £0.00\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  })])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-324d3850!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CruBenefits/Benefit.vue
// module id = 1633
// module chunks = 0